import { Injectable, inject } from '@angular/core';

import { Subject } from 'rxjs';
import { BackendError, BackendErrorResponse, RestErrorEventCategory } from '../../../domain/error.domain';
import { SYSTEM_STATUS_CONFIGURATION } from '../../system-status/system-status.contract';
import { SystemStatusConfiguration } from '../../system-status/system-status.domain';
import { RestErrorHandler } from '../rest-error-handler.service';

@Injectable({
  providedIn: 'root'
}
)
export class RestApplicationErrorHandlerService implements RestErrorHandler {
  private readonly configuration = inject<SystemStatusConfiguration>(SYSTEM_STATUS_CONFIGURATION);

  readonly onCriticalApplicationError: Subject<BackendError>;

  private readonly criticalErrorCode: string;

  constructor() {
    this.onCriticalApplicationError = new Subject<BackendError>();

    this.criticalErrorCode = this.configuration.systemDownErrorCode ?? '';
  }

  handleErrors(errors: Array<BackendError>): BackendErrorResponse {
    let result: BackendErrorResponse;
    for (const error of errors) {
      if (this.isCriticalError(error)) {
        result = { ...error, category: RestErrorEventCategory.SYSTEM_DOWN };
        this.onCriticalApplicationError.next(result);
        break;
      }
      if (this.isSystemOverlayError(error)) {
        result = { ...error, category: RestErrorEventCategory.ERROR };
        break;
      }
    }
    return result;
  }

  private isCriticalError(error: BackendError): boolean {
    return error.code === this.criticalErrorCode;
  }

  private isSystemOverlayError(error: BackendError): boolean {
    return error.code === 'JOURNALS_OTHER_ERROR';
  }

}
